export const NONE_OF_THE_ABOVE_OPTION = 'None Of The Above';
